import { render, staticRenderFns } from "./PhotoWall3D.vue?vue&type=template&id=720bbcba&scoped=true&"
import script from "./PhotoWall3D.vue?vue&type=script&lang=js&"
export * from "./PhotoWall3D.vue?vue&type=script&lang=js&"
import style0 from "./PhotoWall3D.vue?vue&type=style&index=0&id=720bbcba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720bbcba",
  null
  
)

export default component.exports